import graphActionCreators from "Areas/Documents/graph/redux/actionCreators";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import SwitcherFeed from "./switcherFeed";
const mapDispatchToProps = (dispatch) => ({
    onLoadNodeContent: (documentId, nodeId, masterNodeId, completed, rejected) => {
        dispatch(actionCreators.getNodeContent(documentId, nodeId, masterNodeId, completed, rejected));
    },
    onPhotoSendToGraph: (documentId, url, documentObjects, fromNodeSourceId, fromNodeSourceGroupId) => dispatch(graphActionCreators.appendPhotoToUpdates(documentId, url, documentObjects, fromNodeSourceId, fromNodeSourceGroupId)),
    onTextSendToGraph: (documentId, text, documentObjects, fromNodeSourceId, fromNodeSourceGroupId) => dispatch(graphActionCreators.appendTextToUpdates(documentId, text, documentObjects, fromNodeSourceId, fromNodeSourceGroupId))
});
export default connect(undefined, mapDispatchToProps)(SwitcherFeed);
